import { PkButton, PkIcon } from '@uefadigital/panenka-react';
import { useTranslation } from 'react-i18next';

import { useLikeButtonState } from '../../hooks';
import { useNomineeEntity } from '../../hooks/useNomineeEntity';
import { actions } from '../../models';
import { useAppDispatch, useAppSelector } from '../../store';
import type { NomineeType, PollType } from '../../types';
import { pushUserVote } from '../../utils/apis';
import GoogleTagManagerHelper from '../../utils/googleTagManager';
import LocalStorageClient from '../../utils/LocalStorageClient';

import * as style from './style.module.scss';

const LikeButtonGOTS = ({ nominee, poll }: { nominee: NomineeType; poll: PollType }) => {
  const { t } = useTranslation();
  const user = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const { isVoted, isButtonDisabled, isButtonHidden } = useLikeButtonState(poll, nominee);
  const nomineeEntity = useNomineeEntity(nominee);

  const voteClick = async () => {
    GoogleTagManagerHelper.event(
      'Click',
      `Vote - ${nomineeEntity.internationalName} - ${nomineeEntity.id}`,
      `gots - ${poll.title}`,
      { section_reference: 'gots' },
      'gots_vote',
    );
    const list = `${GoogleTagManagerHelper.getFromDataLayer('pageType')}-${GoogleTagManagerHelper.getFromDataLayer(
      'pageSubType',
    )}`;
    GoogleTagManagerHelper.gtmCardClick([
      {
        item_id: poll.id,
        item_category: 'gots',
        item_name: 'gots vote',
        item_list_name: list,
      },
    ]);

    user && (await pushUserVote(poll, nominee, user));

    LocalStorageClient.trackVote(poll, nominee, user);
    dispatch(actions.user.setUserVoted(poll));
    if (user.isLogged) {
      dispatch(actions.user.setPageStatus('VOTING_COMPLETE'));
    } else {
      dispatch(actions.user.setPageStatus('ENTER_PRIZE_DRAW'));
    }
  };

  return (
    <>
      {!isButtonHidden && (
        <PkButton
          className={style.btnVote}
          color='interaction'
          appearance='outlined'
          onPkClick={voteClick}
          disabled={isVoted || isButtonDisabled}>
          {isVoted ? (
            <div className={style.gotsVoted}>
              {isVoted && <span className={style.votedLabel}>{t('gots.voted')}</span>}
              <PkIcon name='actions-check' size='24' color='interaction' />
            </div>
          ) : (
            t('gots.vote')
          )}
        </PkButton>
      )}
      {isButtonHidden && isVoted && (
        <span className={style.votedIcon}>
          <span>
            <PkIcon name='actions-check' size='24' color='interaction' />
          </span>
          <span className={style.votedLabel}>{t('gots.voted')}</span>
        </span>
      )}
    </>
  );
};

export default LikeButtonGOTS;
